var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 75.2671C68.163 75.2671 68.7989 75.0037 69.2678 74.5349C69.7366 74.066 70 73.4301 70 72.7671V40.8921C70 39.8251 69.7898 38.7686 69.3815 37.7828C68.9732 36.797 68.3747 35.9013 67.6202 35.1468C66.8658 34.3924 65.9701 33.7939 64.9843 33.3856C63.9985 32.9772 62.942 32.7671 61.875 32.7671H55V13.3921C55 12.3251 54.7898 11.2686 54.3815 10.2828C53.9732 9.29702 53.3747 8.40132 52.6202 7.64685C51.8658 6.89237 50.9701 6.29389 49.9843 5.88557C48.9985 5.47725 47.942 5.26709 46.875 5.26709H17.5C15.5109 5.26709 13.6032 6.05727 12.1967 7.46379C10.7902 8.87031 10 10.778 10 12.7671V72.7671C10 73.4301 10.2634 74.066 10.7322 74.5349C11.2011 75.0037 11.837 75.2671 12.5 75.2671H67.5Z",
    fill: "url(#paint0_linear_43592_17148)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 60.2671C54.7446 60.2671 55.6984 60.6622 56.4016 61.3654C57.1049 62.0687 57.5 63.0225 57.5 64.0171V75.2671H40L37.5 69.0171L40 60.2671H53.75Z",
    fill: "url(#paint1_linear_43592_17148)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 60.2671C25.2554 60.2671 24.3016 60.6622 23.5983 61.3654C22.8951 62.0687 22.5 63.0225 22.5 64.0171V75.2671H40V60.2671H26.25Z",
    fill: "url(#paint2_linear_43592_17148)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 25.2671C27.2446 25.2671 28.1984 24.872 28.9017 24.1687C29.6049 23.4655 30 22.5117 30 21.5171C30 20.5225 29.6049 19.5687 28.9017 18.8654C28.1984 18.1622 27.2446 17.7671 26.25 17.7671C25.2554 17.7671 24.3016 18.1622 23.5983 18.8654C22.8951 19.5687 22.5 20.5225 22.5 21.5171C22.5 22.5117 22.8951 23.4655 23.5983 24.1687C24.3016 24.872 25.2554 25.2671 26.25 25.2671ZM26.25 37.7671C27.2446 37.7671 28.1984 37.372 28.9017 36.6687C29.6049 35.9655 30 35.0117 30 34.0171C30 33.0225 29.6049 32.0687 28.9017 31.3654C28.1984 30.6622 27.2446 30.2671 26.25 30.2671C25.2554 30.2671 24.3016 30.6622 23.5983 31.3654C22.8951 32.0687 22.5 33.0225 22.5 34.0171C22.5 35.0117 22.8951 35.9655 23.5983 36.6687C24.3016 37.372 25.2554 37.7671 26.25 37.7671ZM30 46.5171C30 47.5117 29.6049 48.4655 28.9017 49.1687C28.1984 49.872 27.2446 50.2671 26.25 50.2671C25.2554 50.2671 24.3016 49.872 23.5983 49.1687C22.8951 48.4655 22.5 47.5117 22.5 46.5171C22.5 45.5225 22.8951 44.5687 23.5983 43.8654C24.3016 43.1622 25.2554 42.7671 26.25 42.7671C27.2446 42.7671 28.1984 43.1622 28.9017 43.8654C29.6049 44.5687 30 45.5225 30 46.5171ZM38.75 25.2671C39.7446 25.2671 40.6984 24.872 41.4016 24.1687C42.1049 23.4655 42.5 22.5117 42.5 21.5171C42.5 20.5225 42.1049 19.5687 41.4016 18.8654C40.6984 18.1622 39.7446 17.7671 38.75 17.7671C37.7554 17.7671 36.8016 18.1622 36.0983 18.8654C35.3951 19.5687 35 20.5225 35 21.5171C35 22.5117 35.3951 23.4655 36.0983 24.1687C36.8016 24.872 37.7554 25.2671 38.75 25.2671ZM42.5 34.0171C42.5 35.0117 42.1049 35.9655 41.4016 36.6687C40.6984 37.372 39.7446 37.7671 38.75 37.7671C37.7554 37.7671 36.8016 37.372 36.0983 36.6687C35.3951 35.9655 35 35.0117 35 34.0171C35 33.0225 35.3951 32.0687 36.0983 31.3654C36.8016 30.6622 37.7554 30.2671 38.75 30.2671C39.7446 30.2671 40.6984 30.6622 41.4016 31.3654C42.1049 32.0687 42.5 33.0225 42.5 34.0171ZM38.75 50.2671C39.7446 50.2671 40.6984 49.872 41.4016 49.1687C42.1049 48.4655 42.5 47.5117 42.5 46.5171C42.5 45.5225 42.1049 44.5687 41.4016 43.8654C40.6984 43.1622 39.7446 42.7671 38.75 42.7671C37.7554 42.7671 36.8016 43.1622 36.0983 43.8654C35.3951 44.5687 35 45.5225 35 46.5171C35 47.5117 35.3951 48.4655 36.0983 49.1687C36.8016 49.872 37.7554 50.2671 38.75 50.2671ZM55 46.5171C55 47.5117 54.6049 48.4655 53.9016 49.1687C53.1984 49.872 52.2446 50.2671 51.25 50.2671C50.2554 50.2671 49.3016 49.872 48.5984 49.1687C47.8951 48.4655 47.5 47.5117 47.5 46.5171C47.5 45.5225 47.8951 44.5687 48.5984 43.8654C49.3016 43.1622 50.2554 42.7671 51.25 42.7671C52.2446 42.7671 53.1984 43.1622 53.9016 43.8654C54.6049 44.5687 55 45.5225 55 46.5171Z",
    fill: "url(#paint3_linear_43592_17148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43592_17148",
    x1: 40.5236,
    y1: -4.75836,
    x2: 40.5236,
    y2: 81.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08538C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6F5BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F5648B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43592_17148",
    x1: 40,
    y1: 57.7671,
    x2: 52.8725,
    y2: 72.8096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43592_17148",
    x1: 24.6875,
    y1: 57.7671,
    x2: 37.7133,
    y2: 71.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_43592_17148",
    x1: 26.5625,
    y1: 12.3504,
    x2: 54.5483,
    y2: 36.8781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6E7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.943919da83aed4f21a8ef984bc9f4a4c.svg";
export { ForwardRef as ReactComponent };